/**
 * Shared gate for Case Management surfaces: the Account-view Case Management
 * entry and the status-bar employee tenant switcher (`EmployeeSwitcher`).
 */
export function canShowCaseManagementNav(args: {
  isPermissionServiceAvailable: boolean;
  isUserAdmin: boolean;
  caseManagementDashboard?: boolean;
}): boolean {
  return (
    args.isPermissionServiceAvailable &&
    args.isUserAdmin &&
    !!args.caseManagementDashboard
  );
}
